import "./style.css";

export default function Footer() {
  return (
    <footer id="footer">
      <h2>PAULO EDUARDO</h2>
    </footer>
  );
}
